export default __webpack_public_path__ + "static/media/bulbIcon.c76faaea.svg";